export default __webpack_public_path__ + "static/media/Group 3053@2x.ca243541.png";